export const BLOG_LOCALE = "en";
export const ENGLISH_ONLY_CONTENT_ROOT_PATHS = ["/guides", "/news", "/blog"];

export function isEnglishOnlyBlogPath(path: string) {
  return ENGLISH_ONLY_CONTENT_ROOT_PATHS.some(
    (rootPath) => path === rootPath || path.startsWith(`${rootPath}/`),
  );
}
